/* istanbul ignore file  */
import axios from "axios";
import jwt_decode from "jwt-decode";
import { deleteCookiesLoginUser, setCookie } from "./commonUtils";
import Cookies from "js-cookie";

export const clearAllCookies = () => {
  const cookies = document.cookie.split(";");
  console.log(window.location.hostname)
  console.log(cookies)
  cookies.forEach(cookie => {
    const cookieName = cookie.split("=")[0].trim();
    Cookies.remove(cookieName, { path: "/" });
    Cookies.remove(cookieName, { path: "", domain: window.location.hostname });
  });
  console.log('All cookies have been cleared');

  };

export const isTokenValid = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/identity-api/api/v1/users/validateToken`,{ headers: { Authorization: token } }
    );
    deleteCookiesLoginUser();
    const decodeToken = jwt_decode(response?.data?.token);
    setCookie("authToken", `Bearer ${response?.data?.token}`);
    setCookie("userGuid", decodeToken?.userGuid);
    setCookie("username", decodeToken?.firstName);
    setCookie("email", decodeToken?.email);
    setCookie("User", JSON.stringify(decodeToken));
    const isToken = !!response?.data?.token;
    return isToken;
  } 
  catch (error) {
    return false;
  }
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};


export const getUserSession = () => {
  axios
    .get(
      `${process.env.REACT_APP_PLATFORM_URL}services/user/account/sessionstatus.json`
    )
    .then((responce) => {
      document.cookie = `sessionId=${responce.data.userAccSrvRes.userSessionData.sessionId};path=/`;
    })
    .catch((eror) => console.log({ sessionstatus: eror }));
};

export const handlePasswordValidation = (password) => {
  if (password.length >= 6) {
    return true;
  } else {
    return false;
  }
};
